import React from 'react';
import { get } from 'lodash';
import { FormikPropsSlice } from 'primitives/input/formikUtils';
import { getFrontMessage } from 'appMessageDefinitions';
import { ShRadioField } from '@shoootin/components-web';
import { ShText } from '@shoootin/translations';
import { ShService } from '@shoootin/config';

const YesNoRadioGroup = [
  { key: true, label: getFrontMessage('common_actions_yes') },
  { key: false, label: getFrontMessage('common_actions_no') },
];

export const RadioGroupYesNo = <FieldName extends string>({
  form,
  name,
  onCheck,
  service,
}: {
  form: FormikPropsSlice<FieldName>;
  name: FieldName;
  onCheck?: () => void;
  service?: ShService;
}) => {
  return (
    <>
      {YesNoRadioGroup.map(({ key, label }) => {
        return (
          <ShRadioField
            value={get(form.values, name) === key}
            label={<ShText message={label} />}
            onChange={() => {
              form.setFieldValue(name, key);
              onCheck && onCheck();
            }}
            bold={true}
            service={service}
          />
        );
      })}
    </>
  );
};
